import * as axios from 'axios'

// const Prismic = require('prismic-javascript')
// const apiEndpoint = 'https://vadimm-faq.prismic.io/api/v2'
const HOST = process.env.VUE_APP_CMS // VUE_APP_CMS définit dans .env en local , sur netlify la var est définie dans l'admin !

class Api {
  isInit = false
  api = null
  apiEndpoint = null

  constructor () {
    //this.http = axios.create({ baseURL: apiEndpoint })
  }

  async init () {
    /*
    return new Promise((resolve, reject) => {

        Prismic.getApi(apiEndpoint)
          .then((api) => {
            this.api = api
            this.isInit = true
            resolve(api)
          })
          .catch((err) => {
            reject(err)
          })
      })
    })
    */
    // pas d'api a récuperrer en asynchrone en fait maintenant
    // ou tester connexion wp ? recuperrer infos de base ? (le faire apres, pas API )
    // let api = null
    this.api = null
    this.isInit = true
    this.apiEndpoint = HOST+'/wp-json'
    //resolve(api)
    return true

  }

  async fetchContents (value) {
    /*
    return new Promise((resolve, reject) => {
      this.api.query(Prismic.Predicates.at('document.type', value))
        .then((response) => {
          resolve(response.results)
        })
        .catch((err) => {
          reject(err)
        })
    })
    */
  }

  async fetchMeta(pageID){ // le slug wp en fait ( pas l'id numerique de page )
    return new Promise((resolve, reject) => {
      axios.get(this.apiEndpoint+'/markers/v1/meta/'+pageID)
        .then((response) => {
          // console.log('-------------- cmsApi - page (id:'+pageID+') cmsApi --------------'+JSON.stringify(response)+'----------------------------------');
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  async fetchMenu(menuWpRef){
    return new Promise((resolve, reject) => {
      axios.get(this.apiEndpoint+'/menus/v1/menuSimple/'+menuWpRef)
        .then((response) => {
          console.log('-------------- cmsApi - menu (ref:'+menuWpRef+') cmsApi --------------'+JSON.stringify(response)+'----------------------------------');
          resolve(response)
        })
        .catch((error) => {
          if (error.response) {
            // The request was made and the server responded with a status code bthat falls out of the range of 2xx
            // console.log(error.response.data);
            // console.log(error.response.status);
            // console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of http.ClientRequest in node.js
            // console.log(error.request);
          } else { // Something happened in setting up the request that triggered an Error
            // console.log('Error', error.message);
          }
          // console.log(error.config);
          reject(error)
        })
    })
  }

  async fetchPage(pageID){ // le slug wp en fait ( pas l'id numerique de page )
    return new Promise((resolve, reject) => {
      axios.get(this.apiEndpoint+'/markers/v1/post/'+pageID)
        .then((response) => {
          // console.log('-------------- cmsApi - page (id:'+pageID+') cmsApi --------------'+JSON.stringify(response)+'----------------------------------');
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  async fetchSiteInfos(){ // le slug wp en fait ( pas l'id numerique de page )
    return new Promise((resolve, reject) => {
      axios.get(this.apiEndpoint+'/global/v1/siteInfos')
        .then((response) => {
          console.log('-------------- cmsApi - fetchSiteInfos --------------'+JSON.stringify(response)+'----------------------------------');
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  async fetchSearchResults(searchQuerry){
    return new Promise((resolve, reject) => {
      axios.get(this.apiEndpoint+'/global/v1/searchResults/?search='+searchQuerry) // requette custom - passe requette en get et pas juste chemin (résoup interprétation accents et espaces coté wp )
      // axios.get(this.apiEndpoint+'/global/v2/search/'+searchQuerry) // API search rest WP par def ?
        .then((response) => {
          console.log('-------------- cmsApi - fetchSearchResults --------------'+JSON.stringify(response)+'----------------------------------');
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }





  /*
  async fetchByID (id) {
    return new Promise((resolve, reject) => {
      this.api.getByID(id)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  async fetchByIDs (ids) {
    return new Promise((resolve, reject) => {
      this.api.getByIDs(ids)
        .then((response) => {
          resolve(response.results)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
  */
}

const api = new Api({ host: HOST+'/wp-json' })

export {
  api
}
